import { render } from "./image-element.vue?vue&type=template&id=b75c8b54"
import script from "./image-element.vue?vue&type=script&lang=js"
export * from "./image-element.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__